import ContactUsForm from '../components/ContactUsForm/ContactUsForm';
import Footer from '../components/Footer/Footer';

export default function ContactUsPage() {
  return (
    <>
      <div className="contact-us-layout">
        <main className="container">
          <ContactUsForm />
        </main>
        <Footer />
      </div>
    </>
  );
}
